import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';

import {AuthResponse} from './model/authResponse';
import {Organisation} from './model/organisation';
import {User} from './model/user';
import {UserProgress} from './model/userProgress';
import {AuthService} from './services/auth.service';
import {OrganisationsService} from './services/organisations.service';
import { Module } from './model/module';
import { ExamResult } from './model/examResult';

@Injectable()
export class OrganisationsDataManager {
  constructor(private organisationsService: OrganisationsService) {}

  public getAllOrganisations(): Observable<Organisation[]> {
    return this.organisationsService.getAllOrganisations();
  }

  public createOrganisation(
      organisationName: string, licences: string, url: string,
      anonymised: boolean, administrator_mail_address: string): Observable<Organisation> {
    return this.organisationsService.createOrganisation(
        organisationName, licences, url, anonymised, administrator_mail_address);
  }

  public updateOrganisation(organisation: Organisation): Observable<Organisation> {
    return this.organisationsService.updateOrganisation(organisation);
  }

  public deleteOrganisation(id): Observable<Organisation> {
    return this.organisationsService.deleteOrganisation(id);
  }

  public getOrganisationById(organisationId): Observable<Organisation> {
    return this.organisationsService.getOrganisationById(organisationId);
  }

  public getProgressByOrganisation(organisationId): Observable<UserProgress[]> {
    return this.organisationsService.getProgressByOrganisation(organisationId);
  }

  public getExamsByOrganisation(organisationId): Observable<ExamResult[]> {
    return this.organisationsService.getExamsByOrganisation(organisationId);
  }

  public getAllModulesByOrganisation(organisationId: string): Observable<Module[]> {
    return this.organisationsService.getAllModulesByOrganisation(organisationId);
  }
}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/data/organisations.datamanager.ts